import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0099 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="労働基準監督署について。調査内容と対応法とは？" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2026.02.20</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        労働基準法、労働安全衛生法、労災保険法、最低賃金法等のいわゆる労働関係法令の指導監督等の為に設置されている労働基準監督署については、様々な機能を待ち合わせています。今回は労働基準監督署はどのようなところなのか、あるいは何をしてくれ、どのような相談に対応してくれるのか、労働局との間違いや、人事労務担当者が恐れる調査内容についても解説します。
      </p>
      <img src="/images/column/details/c0099.jpg" alt="キンクラコラム画像99" />
      <div id="toc1">
        <h1>労働基準監督署の機能とは？</h1>
      </div>
      <p>
        <span>
          労働基準法等の法令遵守ができていない事業所に対して指導または監督することが主たる役割
        </span>
        となります。特に、労働基準法は
        <span>労働者保護を掲げる法律とも言われており</span>
        、労働基準法違反となっている場合には、事業主に対して
        <span>
          罰金等の罰則が適用されるため、未然に防ぐ意味でも中立的な立場に立つ公的機関が指導監督する
        </span>
        ことが求められます。
        <br />
        <br />
        また、使用者側あるいは労働者側からの相談対応も担っています。特に労働者側から労働基準監督署へ相談を持ち掛けたことを根拠として不利益対応する事は法律上許されておらず、この点からも労働者保護が掲げられていると言えます。具体的な相談内容については、
        <span>解雇や未払い残業代があることなどが相談内容としては多い傾向</span>
        です。ただし、あくまで労働基準監督署としては、労働基準法等に沿っているか否かは判断することができますが、契約内容については、そもそも労使間で充分な話し合いを持って決めるべき問題であり、例えば労働基準法上取り決めのない固定残業代については、労働基準監督官であったとしても、具体的な内容に踏み込んでまでの相談対応については難しいと考えられます。
        <br />
        <br />
        万が一、当該相談によって
        <span>
          明白な労働基準法違反が明らかになった場合は、後日当該事業主に対して調査等が行われることもあり得ます
        </span>
        。もちろん、当該調査において労働基準法違反が確認された場合には、是正勧告書等が交付され、当該企業においては旧来から続けてきた運用を変更することになります。
      </p>

      <div id="toc2">
        <h1>労働局と労基署の違いとは？</h1>
      </div>
      <p>
        まず、
        <span>労働局とは、労働基準監督署の上位機関に位置づけられます</span>
        。役割の違いとしては、
        <span>
          労働基準監督署は、労働基準法等の法令違反を是正することが役割であるのに対し、労働局は個別の労使紛争に対して相談対応をすることです
        </span>
        。個別の紛争に対しては、労働局は斡旋と言い、労使の中間的な立場を取り、双方に助言をします。もちろん当該斡旋でも労使間の紛争が解決しなかった場合には、労働審判や裁判に移ることもあります。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>労働基準監督署の調査について</h1>
      </div>
      <p>
        重大な違反の場合は、無告知での立ち入り調査もありますが、そのようなケースを除き、事前に事業主に対して通知があります。そもそも
        <span>調査に至る背景としては、次の2つが考えられます</span>
        。1つは
        <span>
          所属する従業員からの内部告発が契機となって立ち入り調査に至る場合
        </span>
        です。2つ目は、当該地域における定期監督と言うケースが考えられます。いずれのケースにおいても、
        <span>一定の書類の準備が求められます</span>
        。まずは法定三帳簿と呼ばれる労働者名簿、出勤簿、賃金台帳の準備が必要となります。また、労働基準法1つをとっても条文数は100を超え、すべての項目をチェックする事はほぼ不可能ですので、何らかの根拠条文（例えば年次有給休暇や労働時間）を重点的に調査すると言うケースが通常です。
        <br />
        <br />
        年次有給休暇であれば、有給管理簿の備え付けがされているか、年5日の取得義務が遵守されているか、付与日数が適切かなどが挙げられます。
        <br />
        <br />
        次に、労働時間については、残業時間の計算が適切か、残業代の算出方法が適切か、最低賃金を下回っていないか、深夜割り増しが加味されているか
        （深夜帯での労働がある場合）が考えられます。
        <br />
        <br />
        当日用意する書類において、記録の改ざんは許されませんので、現在備え付けている資料をそのまま準備し、当日、調査を受けることが適切である事は言うまでもありません。
      </p>

      <div id="toc4">
        <h1>調査の中で指摘された場合の対応方法とは？</h1>
      </div>
      <p>
        多くの調査で
        <span>
          100%すべて正しく何も指摘されないと言うケースは多くありません
        </span>
        。労働基準法1つとっても、法律の内容は細かく、その証拠に
        <span>通達と呼ばれるものが存在します</span>
        。なお、通達とは行政の上機関が下位の行政機関に対して、
        <span>法令の解釈や運用の方針等を指示する文書です</span>
        。その証拠に通達の数はかなりの数が存在し、専門家であっても、すべての通達を熟知しているケースはほぼありません。
        <br />
        <br />
        実際に調査の中で指摘された場合には、デッドラインを設けられ、改善した結果、報告書類などを労働基準監督署へ提出することが求められます。当然企業規模が多くなればなるほど、提出すべき報告書類は膨大な数となる傾向です。ただし、近年は、各種ITツールが発達しており、当該ITツールを正しく設定し、出力することで報告の形式が紙ベースであったとしても、かなりの時間を節約することができます。
      </p>

      <div id="toc5">
        <h1>最後に</h1>
      </div>
      <p>
        企業が存在する限り、短期間で廃業したと言うような特殊なケースを除き、1度も労働基準監督者の調査に当たらないと言うケースはあまり聞きません。むしろ逆の発想でいつ調査に来られても良いように、前述のITツールを活用することで、より、生産的かつ適切な労務管理体制を構築し、余裕を持って対応できるようにしておくことが良いと考えます。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0099
